import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class TimecardService extends AbstractService {
	static endpoint = ENDPOINTS.timecards;

	static timecardsApi = NexusService.timecardsApi;

	static timecardAttachmentsApi = NexusService.timecardAttachmentsApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_timecards";

	static createTimecard(data) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const createReq = {
				timecardCreatePayload: {},
			};

			if (Object.hasOwn(data, "ClockInTime")) {
				createReq.timecardCreatePayload.ClockInTime = new Date(data.ClockInTime);
			}
			if (Object.hasOwn(data, "ClockOutTime")) {
				createReq.timecardCreatePayload.ClockOutTime = new Date(data.ClockOutTime);
			}
			if (Object.hasOwn(data, "Reason")) {
				createReq.timecardCreatePayload.Reason = data.Reason;
			}
			if (Object.hasOwn(data, "JobId")) {
				createReq.timecardCreatePayload.JobId = data.JobId;
			}
			if (Object.hasOwn(data, "AssignedOfficerId")) {
				createReq.timecardCreatePayload.AssignedOfficerId = data.AssignedOfficerId;
			}
			return this.timecardsApi.createTimecard(createReq).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.post({
			endpoint: this.endpoint,
			data,
		});
	}

	static updateTimecard(data) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const updateTimecardRequest = {
				timecardUpdatePayload: {},
			};

			if (Object.hasOwn(data, "Id")) {
				updateTimecardRequest.timecardUpdatePayload.Id = data.Id;
			}

			if (Object.hasOwn(data, "ClockInTime")) {
				updateTimecardRequest.timecardUpdatePayload.ClockInTime = new Date(
					data.ClockInTime,
				);
			}
			if (Object.hasOwn(data, "ClockOutTime")) {
				updateTimecardRequest.timecardUpdatePayload.ClockOutTime = new Date(
					data.ClockOutTime,
				);
			}
			if (Object.hasOwn(data, "Reason")) {
				updateTimecardRequest.timecardUpdatePayload.Reason = data.Reason;
			}
			return this.timecardsApi.updateTimecard(updateTimecardRequest).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.put({
			endpoint: this.endpoint,
			data,
		});
	}

	static getTimeCardByJobIdAndOfficerId(jobId, officerId) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				jobId,
				assignedOfficerId: officerId,
			};
			return this.timecardsApi
				.lookupTimecard(request)
				.then(response => {
					const apiResponse = {
						data: response,
					};
					return apiResponse;
				})
				.catch(() => ({ data: null }));
		}
		return this.get({
			endpoint: `${this.endpoint}?jobId=${jobId}&assignedOfficerId=${officerId}`,
		});
	}

	static getAttachmentsById(id) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				timecardId: id,
			};
			return this.timecardAttachmentsApi.getTimecardAttachments(request).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.get({
			endpoint: `${this.endpoint}/attachments?timecardId=${id}`,
		});
	}

	static addAttachment(id, fileData) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				timecardId: id,
				file: fileData,
			};
			return this.timecardAttachmentsApi.createTimecardAttachment(request).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		const data = new FormData();
		data.append("file", fileData);
		return this.post({
			endpoint: `${this.endpoint}/attachments?timecardId=${id}`,
			data,
		});
	}

	static deleteAttachment(id, attachmentId) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				timecardId: id,
				timecardAttachmentId: attachmentId,
			};
			return this.timecardAttachmentsApi.deleteTimecardAttachment(request).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.del({
			endpoint: `${this.endpoint}/attachments?timecardId=${id}&timecardAttachmentId=${attachmentId}`,
		});
	}
}
